import { useNavigate } from "react-router-dom";
import { parseHelpMessageSegments } from "../../lib/helpNavigation";

export function HelpMessageContent({ content, variant = "assistant", onNavigate }) {
  const navigate = useNavigate();
  const segments = parseHelpMessageSegments(content);
  const isUser = variant === "user";

  const handleNavigate = (path) => {
    onNavigate?.(path);
    navigate(path);
  };

  if (segments.length === 1 && segments[0].type === "text") {
    return <>{segments[0].value}</>;
  }

  return (
    <>
      {segments.map((seg, i) => {
        if (seg.type === "text") {
          return <span key={`t-${i}`}>{seg.value}</span>;
        }
        return (
          <button
            key={`l-${i}-${seg.path}`}
            type="button"
            onClick={() => handleNavigate(seg.path)}
            title={`Open ${seg.path}`}
            className={
              isUser
                ? "inline font-semibold text-white underline-offset-2 hover:underline"
                : "inline font-semibold text-teal-700 underline-offset-2 hover:text-teal-900 hover:underline"
            }
          >
            {seg.label}
          </button>
        );
      })}
    </>
  );
}
